export default "__VITE_ASSET__CRgmpJDf__"